import { render, staticRenderFns } from "./SettingsLive.vue?vue&type=template&id=20eab230"
import script from "./SettingsLive.vue?vue&type=script&lang=js"
export * from "./SettingsLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports